import React from "react";

import NumberFormat from "react-number-format";

import { getBaseCurrency, symbolFor, isMulticurrency } from "../../core/currency";

const Money = ({
  amount,
  zero = false,
  className = "",
  style,
  euro = false,
  currency,
}) => {
  if (!amount && zero !== false) {
    return zero;
  }

  if (amount === 0 || !amount) {
    return (
      <span style={style} className={className}>
        &nbsp;
      </span>
    );
  }

  let suffix = "",
    prefix = "";
  if (currency) {
    switch (currency.toLowerCase()) {
      case "eur":
        suffix = "€";
        break;
      case "gbp":
        prefix = "£";
        break;
      case "usd":
        prefix = "$";
        break;
      default:
        // hkd/chf/aed/usdt etc — use the shared symbol as a prefix
        // (consistent with symbolFor across the app), not a bare suffix code.
        prefix = symbolFor(currency);
    }
  } else if (euro) {
    suffix = "€";
  } else if (isMulticurrency()) {
    // No explicit currency: the store base decides the symbol. Only active
    // once multi-currency is seeded — legacy renders keep the £ prefix below.
    prefix = symbolFor(getBaseCurrency());
  } else {
    prefix = "£";
  }

  return (
    <NumberFormat
      value={amount / 100}
      displayType={"text"}
      thousandSeparator={true}
      // Display rounding only — all amounts render to exactly 2 decimals;
      // stored values are never mutated.
      decimalScale={2}
      fixedDecimalScale
      prefix={prefix}
      suffix={suffix}
      className={className}
      style={style}
    />
  );
};

export default Money;
